import React, { memo, useRef, useEffect, useState } from "react";
import { audioFileUrl, transcriptFileUrl } from "../api-config.mjs";
import { recordEvent } from "../components/Analytics";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import defaultUser from "../img/user-preview.png";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

// import shareImage from "../img/share.svg";
// import heartImage from "../img/heart.svg";

import downloadImage from "../img/download.svg";
import backwardImage from "../img/backward.svg";
import fastForwardImage from "../img/fast-forward.svg";
import NoCallBg from "../img/no-callBg.png";
import abmIndustryImage from "../img/abm-industry.png";
import rightArrowImage from "../img/right-arrow.svg";
import telephone2Image from "../img/telephone-2.svg";

import log from "loglevel";
import { dayAndTime } from "../components/Dates.mjs";
import { callLink, companyLink } from "../components/Links.mjs";
import { Link } from "../components/Router";
import { isAfter } from "date-fns";
import {
  FaInfoCircle,
  FaServer,
  FaHandPaper,
  FaCheckSquare,
  FaPlayCircle,
} from "react-icons/fa";
import { useSessionContext } from "components/Session";
import getTimeCodeFromNum from "components/PlayerTime";
import SiteHead from "./SiteHead";

import "../sass/call.scss";
import "../sass/schedule-call.scss";
import SignUpForAlerts from "./auth/SignUpForAlerts";
import {
  isFeatureEnabled,
  LOGIN_WITH_EMAIL,
  RENDER_NEW_SCHEDULED_SECTION,
  SPEAKER_NAMES,
} from "components/Features";
import ScheduleInfo from "./ScheduleInfo";
import CompanyDetails from "./CompanyDetails";
import MoreCalls from "./MoreCalls";
import { CompanyLogoDiv } from "./Logo";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

const getCurrentWord = (items, time) => {
  // log.debug("getCurrentWord time:", time);
  if (!items) {
    return null;
  }
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    const { start_time, end_time, alternatives } = item;
    const start = +start_time;
    const end = +end_time;

    // log.info("BLAH", start, time, end);
    if (start <= time && time <= end) {
      // log.info("Yes", alternatives);
      const content = alternatives[0].content;
      // log.info("Content:", content);
      return { index, content };
    }
  }
  return 0;
};

const getCurrentWordV2 = (
  speakerGroups,
  time,
  currentSpeakerGroupIndex,
  currentWordIndex
) => {
  // log.debug("getCurrentWordV2 time:", time);
  if (!speakerGroups || !time) {
    return { wordIndex: -1, speakerGroupIndex: -1 };
  }
  // log.debug("speakerGroups:", speakerGroups);
  let speakerGroupIndex = Math.max(currentSpeakerGroupIndex, 0);
  let wordIndex = Math.max(currentWordIndex, 0);
  if (time < speakerGroups[speakerGroupIndex].start_times[wordIndex]) {
    // In case of rewind:
    speakerGroupIndex = 0;
    wordIndex = 0;
  }
  while (
    speakerGroupIndex < speakerGroups.length - 1 &&
    time > speakerGroups[speakerGroupIndex + 1].start_times[0]
  ) {
    speakerGroupIndex++;
    wordIndex = 0;
  }
  while (
    wordIndex < speakerGroups[speakerGroupIndex].start_times.length - 1 &&
    time > speakerGroups[speakerGroupIndex].start_times[wordIndex + 1]
  ) {
    wordIndex++;
  }
  return { wordIndex, speakerGroupIndex };
};

const getRelativeWordIndex = ({ startIndex, endIndex, currentWordIndex }) => {
  // log.debug("getRelativeWordIndex startIndex:", startIndex, "endIndex:", endIndex, "currentWordIndex:", currentWordIndex);
  if (startIndex <= currentWordIndex && currentWordIndex <= endIndex) {
    return currentWordIndex - startIndex;
  }
  return -1;
};

const groupItemsBySpeaker = ({ items, segments, version, speaker_groups }) => {
  if (version === 2 || version === 3) {
    // Version 2 is already grouped by speaker, so just return it as is.
    return speaker_groups;
  }
  if (!items || !segments) {
    return null;
  }
  if (items.length === 0 || segments.length === 0) {
    return 0;
  }
  const speakerGroups = [];
  let speakerGroup = {
    speaker: segments[0].speaker_label,
    startIndex: 0,
    items: [],
  };
  let segmentIndex = 0;
  // debugger;
  items.forEach((item, itemIndex) => {
    // log.info("Item:", item);
    const { start_time } = item;
    const itemStartTime = +start_time;
    // debugger;
    while (
      itemStartTime > +segments[segmentIndex].end_time &&
      segmentIndex < segments.length
    ) {
      ++segmentIndex;
    }
    if (segmentIndex >= segments.length) {
      log.info("segment:", segmentIndex, segments.length);
    }
    if (speakerGroup.speaker !== segments[segmentIndex].speaker_label) {
      // debugger;
      speakerGroup.endIndex = itemIndex - 1;
      speakerGroups.push(speakerGroup);
      speakerGroup = {
        speaker: segments[segmentIndex].speaker_label,
        startIndex: itemIndex,
        items: [],
      };
    }
    speakerGroup.endIndex = itemIndex - 1;
    speakerGroup.items.push(item);
  });
  speakerGroups.push(speakerGroup);
  return speakerGroups;
};

const getCurrentTimeAudio = (audioElement) => {
  if (audioElement && audioElement.current) {
    return getTimeCodeFromNum(audioElement.current.currentTime);
  }
  return "-";
};

const getDurationTimeAudio = (duration) => {
  if (duration) {
    return getTimeCodeFromNum(duration);
  }
  return "-";
};

const getPlaybackSpeedPrettyVersion = (playbackSpeed) => {
  log.debug(`getPlaybackSpeedPrettyVersion(${playbackSpeed})`);
  return playbackSpeed.toFixed(1);
};

const PauseSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 16.832 20.47"
    >
      <path
        d="M150.568,0h5.043a.538.538,0,0,1,.568.5V19.969a.538.538,0,0,1-.568.5h-5.043a.538.538,0,0,1-.568-.5V.5A.538.538,0,0,1,150.568,0Zm0,0"
        transform="translate(-139.347)"
        fill="#828282"
      />
      <path
        d="M.568,0H5.611a.538.538,0,0,1,.568.5V19.969a.538.538,0,0,1-.568.5H.568a.538.538,0,0,1-.568-.5V.5A.538.538,0,0,1,.568,0Zm0,0"
        fill="#828282"
      />
    </svg>
  );
};

const PlaySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
    >
      <path
        d="M11.143,1.429a1,1,0,0,1,1.715,0L23.091,18.486A1,1,0,0,1,22.234,20H1.766a1,1,0,0,1-.857-1.514Z"
        transform="translate(20) rotate(90)"
        fill="#828282"
      />
    </svg>
  );
};

const AudioControls = ({
  exchange,
  symbol,
  event: { audio_file, year, quarter },
  buildVersion,
  onTimeUpdateHandler,
  audioEventCallback,
  audioElement,
  question_section_start,
}) => {
  const downloadFileName = `${symbol} ${quarter.toUpperCase()} ${year}.mp3`;
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1.0);
  const [volume, setVolume] = useState(100);
  const [playerControlsDisabled, setPlayerControlsDisabled] = useState(true);
  const playbackSpeedPretty = getPlaybackSpeedPrettyVersion(playbackSpeed);
  const haveAudioOffsetForQuestionAnswerSection = !!question_section_start;

  log.debug(
    `AudioControls: duration: ${duration} playerControlsDisabled: ${playerControlsDisabled}`
  );
  log.debug(audioElement);

  const enablePlayerControls = () => {
    log.debug(`AudioControls enablePlayerControls`);
    setPlayerControlsDisabled(false);
  };

  const play = () => {
    if (audioElement && audioElement.current) {
      audioElement.current.play();
      setIsPlaying(true);
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const pause = () => {
    if (audioElement && audioElement.current) {
      audioElement.current.pause();
      setIsPlaying(false);
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const handlePlayPauseButtonClicked = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  const seekRelative = (offset) => {
    if (audioElement && audioElement.current) {
      audioElement.current.currentTime =
        audioElement.current.currentTime + offset;
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const seekBackward = () => {
    recordEvent({
      name: "SeekBackward",
      exchange,
      symbol,
      year,
      quarter,
      currentTime: audioElement.currentTime,
      buildVersion,
    });
    seekRelative(-15);
  };

  const seekForward = () => {
    recordEvent({
      name: "SeekForward",
      exchange,
      symbol,
      year,
      quarter,
      currentTime: audioElement.currentTime,
      buildVersion,
    });
    seekRelative(30);
    // window.scrollBy(0, 50);
  };

  const onDownloadAudioFileClick = () => {
    recordEvent({
      name: "Download",
      exchange,
      symbol,
      year,
      quarter,
      buildVersion,
    });
    // https://www.akashmittal.com/react-download-files-button-click/
    const audioFileLink = document.createElement("a");
    audioFileLink.href = audioFileUrl(audio_file);
    audioFileLink.download = downloadFileName;
    audioFileLink.type = "audio/mpeg";
    document.body.appendChild(audioFileLink);
    audioFileLink.click();
  };

  const onSkipToQuestionAndAnswerSectionButtonClick = () => {
    recordEvent({
      name: "QuestionAndAnswer",
      exchange,
      symbol,
      year,
      quarter,
      currentTime: audioElement.currentTime,
      buildVersion,
    });
    if (audioElement && audioElement.current && question_section_start) {
      audioElement.current.currentTime = question_section_start;
      if (!isPlaying) {
        play();
      }
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const onError = () => {
    log.debug(`The audio element threw an error.`);
  };

  const onCanPlay = () => {
    log.debug("AudioControls onCanPlay");
    enablePlayerControls();
  };

  const onLoadedData = () => {
    log.debug("AudioControls onLoadedData");
    enablePlayerControls();
  };

  const onLoadedMetadata = () => {
    log.debug("AudioControls onLoadedMetadata");
    enablePlayerControls();
  };

  const onDurationChanged = () => {
    log.debug("AudioControls onDurationChanged");
    setDuration(audioElement.current.duration);
    enablePlayerControls();
  };

  const onTimeUpdate = (event) => {
    onTimeUpdateHandler(event);
  };

  const onPlay = (event) => {
    audioEventCallback(event);
    setIsPlaying(true);
  };

  const onPause = (event) => {
    audioEventCallback(event);
    setIsPlaying(false);
  };

  const onAbort = () => {
    log.debug(`AudioControls onAbort`);
  };

  const onEnded = () => {
    log.debug(`AudioControls onEnded`);
  };

  const onSeeked = (event) => {
    log.debug(`AudioControls onSeeked: ${event.target.currentTime}`);
  };

  const seekBarPositionChanged = (event) => {
    const {
      target: { value },
    } = event;
    log.debug(
      `AudioControls seekBarPositionChanged event: ${event} target.value: ${value}`
    );
    if (audioElement && audioElement.current) {
      const fractionalValue = value / 100.0;
      audioElement.current.currentTime = fractionalValue * duration;
    } else {
      log.error("AudioControls AudioElement is missing:", audioElement);
    }
  };

  const playbackSpeedChanged = ({ target: { value } }) => {
    const playbackSpeedAsFloat = parseFloat(value);
    log.debug(`AudioControls PlaybackSpeed: ${playbackSpeedAsFloat}`);
    setPlaybackSpeed(playbackSpeedAsFloat);
    if (audioElement && audioElement.current) {
      audioElement.current.playbackRate = playbackSpeedAsFloat;
    } else {
      log.error("AudioControls AudioElement is missing:", audioElement);
    }
  };

  const volumeSliderChanged = ({ target: { value } }) => {
    log.debug(`AudioControls Volume: ${value}`);
    setVolume(value);
    if (audioElement && audioElement.current) {
      audioElement.current.volume = value / 100.0;
    } else {
      log.error("AudioControls AudioElement is missing:", audioElement);
    }
  };

  const currentTime = getCurrentTimeAudio(audioElement);
  const durationTime = getDurationTimeAudio(duration);

  const seekBarPosition =
    audioElement && audioElement.current
      ? (100 * audioElement.current.currentTime) / duration
      : 0;
  log.debug(
    `AudioControls currentTime: ${currentTime} seekBarPosition: ${seekBarPosition}`
  );

  useEffect(() => {
    // Because of server side rendering, the HTML is returned from the server WITHOUT
    // Event handlers attached to the DOM.  This means we could miss audio loaded events because
    // they are fired before the event handlers are attached.  In this case, we check if the
    // duration does not match what the audioElement duration is, and if so, then set it correctly.
    if (audioElement && audioElement.current && audioElement.current.duration) {
      if (audioElement.current.duration !== duration) {
        setDuration(audioElement.current.duration);
      }
      if (playerControlsDisabled) {
        // We also set the player controls to enabled, since we know the audio is loaded.
        enablePlayerControls();
      }
    }
  }, [audioElement, duration, playerControlsDisabled]);

  return (
    <>
      <div className="col-lg-4 mbl-sticky-top">
        <div className="audio-controls">
          <div className="sticky-top-container">
            <div className="player-container">
              <div className="label-content">
                <span className="qno">{quarter.toUpperCase()}</span>
                <span className="title">
                  <Link to={companyLink(exchange, symbol)}>
                    {symbol.toUpperCase()} {year}
                  </Link>
                </span>
                <div className="content-right">
                  <button
                    type="button"
                    className="btn border-0 btn-qn"
                    id="qa-button"
                    onClick={onSkipToQuestionAndAnswerSectionButtonClick}
                    disabled={!haveAudioOffsetForQuestionAnswerSection}
                  >
                    Q&A
                  </button>
                  <Tooltip
                    title="Download Audio File"
                    position="top"
                    trigger="mouseenter"
                  >
                    <button
                      type="button"
                      className="btn download without-focus border-0"
                      onClick={onDownloadAudioFileClick}
                    >
                      <img src={downloadImage} alt="icon" />
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div className="audio-content">
                <div className="seek-container" id="seek-slider">
                  <input
                    style={{
                      background: `linear-gradient(to right, #4dec8c ${seekBarPosition}%, #ccc ${seekBarPosition}%)`,
                    }}
                    type="range"
                    min="1"
                    max="100"
                    value={seekBarPosition}
                    onChange={seekBarPositionChanged}
                    className="slider"
                  />
                </div>
                {/* Audio Element Docs: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/audio */}
                <audio
                  ref={audioElement}
                  onTimeUpdate={onTimeUpdate}
                  onCanPlay={onCanPlay}
                  onPlay={onPlay}
                  onPause={onPause}
                  onDurationChange={onDurationChanged}
                  onError={onError}
                  onEnded={onEnded}
                  onSeeked={onSeeked}
                  onLoadedData={onLoadedData}
                  onLoadedMetadata={onLoadedMetadata}
                >
                  <source src={audioFileUrl(audio_file)} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>

              <div className="progress-container">
                <p>{currentTime}</p>
                <p>{durationTime}</p>
              </div>

              <div className="info-actions-section">
                <div className="player-action">
                  <div className="play-control">
                    <button
                      id="play-pause-btn"
                      type="button"
                      className="btn"
                      onClick={handlePlayPauseButtonClicked}
                      disabled={playerControlsDisabled}
                    >
                      {isPlaying ? <PauseSvg /> : <PlaySvg />}
                    </button>
                  </div>

                  <ul className="actions-list">
                    <li>
                      <button
                        type="button"
                        className="btn without-focus"
                        id="seek-backward"
                        onClick={seekBackward}
                        disabled={playerControlsDisabled}
                      >
                        <img src={backwardImage} alt="icon" />
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        className="btn without-focus"
                        id="seek-forward"
                        onClick={seekForward}
                        disabled={playerControlsDisabled}
                      >
                        <img src={fastForwardImage} alt="icon" />
                      </button>
                    </li>
                    <li className="d-inline-flex">
                      <Dropdown>
                        <Dropdown.Toggle
                          className="without-focus p-0"
                          variant="default"
                          id="dropdown-basic"
                          bsPrefix="playSpeedDropdown"
                          disabled={playerControlsDisabled}
                        >
                          {`${playbackSpeedPretty}x`}
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="right">
                          <div className="speed-popup">
                            <div className="lbl">Playback Speed</div>
                            <div className="speed-slider">
                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="7.172"
                                  height="8"
                                  viewBox="0 0 7.172 8"
                                >
                                  <path
                                    d="M10.088,1.51a.138.138,0,0,0-.15.031L7.093,4.42V1.638a.138.138,0,0,0-.236-.1L3.041,5.4a.138.138,0,0,0,0,.194L6.857,9.459a.139.139,0,0,0,.236-.1V6.579L9.938,9.459a.138.138,0,0,0,.236-.1V1.638A.139.139,0,0,0,10.088,1.51Z"
                                    transform="translate(-3.001 -1.5)"
                                    fill="#5a5a5a"
                                  />
                                </svg>
                              </span>
                              <span className="slider" id="speed-slider">
                                <input
                                  class="speed"
                                  type="range"
                                  min="0.5"
                                  step=".1"
                                  max="2"
                                  value={playbackSpeed}
                                  onChange={playbackSpeedChanged}
                                  disabled={playerControlsDisabled}
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="7.172"
                                  height="8"
                                  viewBox="0 0 7.172 8"
                                >
                                  <path
                                    d="M3.087,1.51a.138.138,0,0,1,.15.031L6.082,4.42V1.638a.138.138,0,0,1,.236-.1L10.133,5.4a.138.138,0,0,1,0,.194L6.318,9.459a.139.139,0,0,1-.236-.1V6.579L3.237,9.459A.138.138,0,0,1,3,9.362V1.638A.139.139,0,0,1,3.087,1.51Z"
                                    transform="translate(-3.001 -1.5)"
                                    fill="#5a5a5a"
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>

                  <div className="volume-container d-inline-flex">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="without-focus p-0 border-0"
                        variant="default"
                        id="dropdown-basic-volume"
                        bsPrefix="volumeDropdown"
                        disabled={playerControlsDisabled}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21.433"
                          height="20.005"
                          viewBox="0 0 21.433 20.005"
                        >
                          <g transform="translate(0 -15.99)">
                            <path
                              d="M12.456,16.061a.712.712,0,0,0-.756.086l-6.95,5.56H1.429A1.431,1.431,0,0,0,0,23.136v5.716A1.43,1.43,0,0,0,1.429,30.28H4.75L11.7,35.84a.715.715,0,0,0,.757.084.713.713,0,0,0,.4-.643V16.706A.717.717,0,0,0,12.456,16.061Z"
                              fill="#828282"
                            />
                            <path
                              d="M342.968,122.458a.715.715,0,1,0-1,1.017,5.7,5.7,0,0,1,0,8.07.714.714,0,1,0,1,1.015,7.127,7.127,0,0,0,0-10.1Z"
                              transform="translate(-326.491 -101.517)"
                              fill="#828282"
                            />
                            <path
                              d="M388.086,77.332a.715.715,0,0,0-1.007,1.015,8.526,8.526,0,0,1,0,12.1.715.715,0,0,0,1.007,1.015,9.958,9.958,0,0,0,0-14.13Z"
                              transform="translate(-369.593 -58.405)"
                              fill="#828282"
                            />
                          </g>
                        </svg>
                      </Dropdown.Toggle>

                      <Dropdown.Menu align="right">
                        <div className="speed-popup">
                          <div className="lbl">Volume</div>
                          <div className="speed-slider">
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="5.865"
                                height="9.124"
                                viewBox="0 0 5.865 9.124"
                              >
                                <path
                                  d="M5.681,16.023a.325.325,0,0,0-.345.039L2.166,18.6H.652A.653.653,0,0,0,0,19.249v2.607a.652.652,0,0,0,.652.652H2.166l3.169,2.536a.326.326,0,0,0,.345.038.325.325,0,0,0,.184-.293V16.317A.327.327,0,0,0,5.681,16.023Z"
                                  transform="translate(0 -15.99)"
                                  fill="#5a5a5a"
                                />
                              </svg>
                            </span>

                            <span className="slider" id="volume-slider">
                              <input
                                class="volume"
                                type="range"
                                min="1"
                                max="100"
                                value={volume}
                                onChange={volumeSliderChanged}
                                disabled={playerControlsDisabled}
                              />
                            </span>

                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9.775"
                                height="9.124"
                                viewBox="0 0 9.775 9.124"
                              >
                                <path
                                  d="M5.681,16.023a.325.325,0,0,0-.345.039L2.166,18.6H.652A.653.653,0,0,0,0,19.249v2.607a.652.652,0,0,0,.652.652H2.166l3.169,2.536a.326.326,0,0,0,.345.038.325.325,0,0,0,.184-.293V16.317A.327.327,0,0,0,5.681,16.023Z"
                                  transform="translate(0 -15.99)"
                                  fill="#5a5a5a"
                                />
                                <path
                                  d="M342.306,122.346a.326.326,0,0,0-.458.464,2.6,2.6,0,0,1,0,3.681.326.326,0,1,0,.458.463,3.25,3.25,0,0,0,0-4.607Z"
                                  transform="translate(-334.792 -120.089)"
                                  fill="#5a5a5a"
                                />
                                <path
                                  d="M387.423,77.219a.326.326,0,1,0-.459.463,3.888,3.888,0,0,1,0,5.519.326.326,0,0,0,.459.463,4.541,4.541,0,0,0,0-6.444Z"
                                  transform="translate(-378.989 -75.88)"
                                  fill="#5a5a5a"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Player = (props) => {
  log.trace("Player::Render()");
  const {
    exchange,
    symbol,
    companyName,
    event,
    transcript,
    isTranscriptPreview,
    buildVersion,
    speakerGroups,
    speakerNames,
    speakerNamesV2,
  } = props;
  // log.debug("Player::transcript:", transcript);
  const [audioTime, setAudioTime] = useState();
  const [currentSpeakerGroupIndex, setCurrentSpeakerGroupIndex] = useState(-1);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);
  const audioElement = useRef(null);
  const { question_section_start, transcription_type, model_name } =
    transcript || {};
  const { year, quarter, conference_date, audio_file } = event;

  // https://developer.mozilla.org/en-US/docs/Web/API/Event
  const audioEventCallback = (event) => {
    const {
      type,
      target: { currentTime },
    } = event;
    log.trace("audioEventCallback:", event);
    const eventName = type.charAt(0).toUpperCase() + type.slice(1);
    recordEvent({
      name: eventName,
      exchange,
      symbol,
      year,
      quarter,
      currentTime,
      buildVersion,
    });
  };

  const onTimeUpdateHandler = ({ target: { currentTime } }) => {
    if (!transcript) {
      return;
    }
    // log.info("EVENT:", currentTime);
    setAudioTime(currentTime);
  };

  useEffect(() => {
    if (!transcript) {
      return;
    }
    const { items, version, speaker_groups } = transcript;
    if (!version) {
      return;
    }
    if (version === 2 || version === 3) {
      if (speaker_groups && audioTime) {
        const { wordIndex, speakerGroupIndex } = getCurrentWordV2(
          speaker_groups,
          audioTime,
          currentSpeakerGroupIndex,
          currentWordIndex
        );
        setCurrentSpeakerGroupIndex(speakerGroupIndex);
        setCurrentWordIndex(wordIndex);
      }
    } else {
      const { index } = getCurrentWord(items, audioTime);
      setCurrentWordIndex(index);
    }
  }, [transcript, audioTime, currentSpeakerGroupIndex, currentWordIndex]);

  // https://stackoverflow.com/questions/9563887/setting-html5-audio-position
  // https://stackoverflow.com/questions/48206360/firefox-audio-delay-when-seeking-mp3-file
  const seekTo = (time) => {
    if (audioElement && audioElement.current) {
      log.debug(`seekTo: ${time}`);
      if (typeof time === "undefined") {
        log.warn(
          `Skipping assigning currentTime to audioElement due to undefined value: ${time}`
        );
        return;
      }
      audioElement.current.currentTime = time;
      audioElement.current.play();
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const transcriptProps = {
    exchange,
    symbol,
    companyName,
    event,
    isTranscriptPreview,
    transcript: {
      version: transcript && transcript.version,
      transcription_type,
      model_name,
      question_section_start,
    },
    speakerGroups,
    speakerNames,
    speakerNamesV2,
    currentWordIndex,
    currentSpeakerGroupIndex,
    seekTo,
    buildVersion,
  };

  const audioControlsProps = {
    exchange,
    symbol,
    companyName,
    event: { audio_file, year, quarter, conference_date },
    transcript,
    buildVersion,
    onTimeUpdateHandler,
    audioEventCallback,
    audioElement,
    question_section_start,
  };

  return (
    <>
      <div className="col-lg-8 pr-lg-5">
        <Transcript {...transcriptProps} />
      </div>
      <AudioControls {...audioControlsProps} />
    </>
  );
};

const joinItemsToText = ({ items, version }) => {
  const words = [];
  items.forEach((item, i) => {
    if (version === 2 || version === 3) {
      words.push(item);
    } else {
      const { type, alternatives } = item;
      const content = alternatives[0].content;
      if (type === "punctuation") {
        // Push last word with punctation (no space between).
        if (words.length === 0) {
          words.push(content);
        } else {
          words.push(`${words.pop()}${content}`);
        }
      } else {
        words.push(content);
      }
    }
  });
  return words.join(" ");
};

const TranscriptSection = memo(
  ({ items, wordIndex, seekTo, hasWhitespaceSuffix, version }) => {
    log.trace("TranscriptSection::render() wordIndex:", wordIndex);

    const onClick = (clickEvent) => {
      log.debug("clickEvent:", clickEvent);
      log.debug("items[0]:", items[0]);
      seekTo(items[0].start_time);
    };

    // log.debug("TranscriptSection:: key:", key);

    if (wordIndex === -1) {
      return (
        // <span onClick={onClick}>
        <>
          {joinItemsToText({ items, version })}
          {hasWhitespaceSuffix && " "}
        </>
      );
    }

    // log.debug("TranscriptSection items:", items);

    const currentItem = items[wordIndex];
    const currentWord =
      version === 2 || version === 3
        ? currentItem
        : currentItem.alternatives[0].content;
    // log.debug("wordIndex:", wordIndex);
    const currentWordType = currentItem.type;
    const wordAfterCurrentWordType =
      wordIndex < items.length - 1 && items[wordIndex + 1].type;
    const lastWord = wordIndex === items.length - 1;
    const textBefore = joinItemsToText({
      items: items.slice(0, wordIndex),
      version,
    });
    const textAfter = joinItemsToText({
      items: items.slice(wordIndex + 1),
      version,
    });

    return (
      <>
        {/* <span className="call-text"> */}
        {textBefore}
        {currentWordType !== "punctuation" && " "}
        {/* </span> */}
        <span className="current-word">{currentWord}</span>
        {!lastWord && (
          <>
            {wordAfterCurrentWordType !== "punctuation" && " "}
            {textAfter}
          </>
        )}
        {hasWhitespaceSuffix && " "}
      </>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.wordIndex === nextProps.wordIndex;
  }
);

const chunkArrayInGroups = (ar, num) => {
  return ar.reduce(function (r, v, i) {
    if (i % num === 0) r.push(ar.slice(i, i + num));
    return r;
  }, []);
};

const hasWhitespaceSuffix = ({ groupIndex, groups }) => {
  if (groupIndex === groups.length - 1) {
    return false;
  }
  const nextGroup = groups[groupIndex + 1];
  return nextGroup[0].type !== "punctuation";
};

const SpeakerSection = memo(
  ({
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
    speaker: { name: speakerName, title: speakerTitle },
    items,
    words,
    start_times,
    wordIndex,
    seekTo,
    version,
  }) => {
    log.trace("SpeakerSection::render() wordIndex:", wordIndex);
    const WORD_GROUP_SIZE = 20;
    const groups = words
      ? chunkArrayInGroups(words, WORD_GROUP_SIZE)
      : chunkArrayInGroups(items, WORD_GROUP_SIZE);
    const [scrolledIntoView, setScrolledIntoView] = useState(false);
    const speakerSpanRef = useRef(null);
    const sectionStartTime =
      version === 2 || version === 3 ? start_times[0] : items[0].start_time;

    useEffect(() => {
      if (
        wordIndex &&
        wordIndex > -1 &&
        !scrolledIntoView &&
        speakerSpanRef &&
        speakerSpanRef.current
      ) {
        log.debug(`Scrolling speaker ${speakerName} into view.`);
        // speakerSpanRef.current.scrollIntoView(true);
        setScrolledIntoView(true);
      }
    }, [
      scrolledIntoView,
      wordIndex,
      speakerSpanRef,
      speakerName,
      speakerTitle,
    ]);

    const onPlaySectionClick = () => {
      log.debug("onPlaySectionClick", sectionStartTime);
      recordEvent({
        name: "PlaySpeakerSection",
        exchange,
        symbol,
        year,
        quarter,
        currentTime: sectionStartTime,
        buildVersion,
      });
      seekTo(sectionStartTime);
    };

    return (
      <>
        <div className="content without-focus">
          <div className="speaker" ref={speakerSpanRef}>
            <div className="speaker-info">
              <div className="img-container">
                <img src={defaultUser} alt="speaker" />
              </div>
              <div>
                <div className="speaker-name">{speakerName}</div>
                <div className="designation">{speakerTitle}</div>
              </div>
            </div>
            <button
              className="btn play-speaker-section without-focus border-0"
              onClick={onPlaySectionClick}
              aria-label={`Play ${speakerName} at ${sectionStartTime} seconds`}
            >
              <FaPlayCircle />
            </button>
          </div>
          <div>
            <p className="call-text">
              {groups.map((items, i) => (
                <TranscriptSection
                  key={i}
                  wordIndex={getRelativeWordIndex({
                    startIndex: WORD_GROUP_SIZE * i,
                    endIndex: WORD_GROUP_SIZE * i + WORD_GROUP_SIZE - 1,
                    currentWordIndex: wordIndex,
                  })}
                  items={items}
                  seekTo={seekTo}
                  hasWhitespaceSuffix={hasWhitespaceSuffix({
                    groupIndex: i,
                    groups,
                  })}
                  version={version}
                />
              ))}
            </p>
          </div>
        </div>
      </>
    );
  },
  (prevProps, nextProps) => {
    // log.debug("nextProps:", nextProps);
    return prevProps.wordIndex === nextProps.wordIndex;
  }
);

const TranscriptPreviewExplanation = (props) => {
  // debugger;

  const {
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
  } = props;

  const [buttonClicked, setButtonClicked] = useState(false);

  const LetUsKnowButtonClicked = (event) => {
    event.preventDefault();
    setButtonClicked(true);
    recordEvent({
      name: "RequestTranscript",
      exchange,
      symbol,
      year,
      quarter,
      buildVersion,
    });
  };

  return (
    <>
      <div className="about-call">
        <div className="title">Looking for More?</div>
        <div className="content">
          <p className="text">
            This transcript is an excerpt of the full conference call. Right now
            our servers are busy working on other stuff. (<FaServer />) If
            you're interested in the full conference call transcript please let
            us know by clicking the button below.
          </p>
          <Button onClick={LetUsKnowButtonClicked} disabled={buttonClicked}>
            {buttonClicked ? (
              <>
                <FaCheckSquare /> Got it, thanks!
              </>
            ) : (
              <>
                <FaHandPaper /> Request Full Transcript
              </>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

const getSpeakerSectionWordIndex = ({
  activeSpeakerGroup,
  version,
  startIndex,
  endIndex,
  currentWordIndex,
}) => {
  if (version === 2 || version === 3) {
    if (activeSpeakerGroup) {
      return currentWordIndex;
    }
    return -1;
  }
  return getRelativeWordIndex({ startIndex, endIndex, currentWordIndex });
};

const Transcript = ({
  exchange,
  symbol,
  companyName,
  event: { year, quarter, conference_date, transcript: transcriptFile },
  isTranscriptPreview,
  transcript: {
    version,
    question_section_start,
    transcription_type,
    model_name,
  },
  currentSpeakerGroupIndex,
  currentWordIndex,
  seekTo,
  speakerGroups,
  speakerNames,
  speakerNamesV2,
  buildVersion,
}) => {
  log.trace("Transcript::Render() currentWordIndex:", currentWordIndex);
  const {
    sessionContext: { isAdminUser },
  } = useSessionContext();
  const transcriptTitle = `${companyName} — ${quarter.toUpperCase()} ${year} Earnings Conference Call`;
  const conferenceDate = new Date(conference_date);
  const { date, day, time } = dayAndTime(conferenceDate);
  // log.debug("Day time:", date, day, time);
  // log.debug("speakerGroups:", speakerGroups);
  // debugger;

  const transcriptPreviewExplanationProps = {
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
  };

  const enableSpeakerNames = isFeatureEnabled(SPEAKER_NAMES);
  const haveAudioOffsetForQuestionAnswerSection = !!question_section_start;

  const getSpeakerObject = (speakerLabel) => {
    if (speakerNamesV2 && speakerNamesV2[speakerLabel]) {
      // Speaker name mapping V2 found, return the speaker name and title
      return speakerNamesV2[speakerLabel];
    }
    if (speakerNames && speakerNames[speakerLabel]) {
      // Speaker name mapping V1 found, return the speaker name.  Title is not available for V1
      return {
        name: speakerNames[speakerLabel],
        title: null,
      };
    }
    // No speaker mapping found, return the original speaker label
    return {
      name: speakerLabel,
      title: null,
    };
  };

  const transcriptDownloadFileName = `${exchange}_${symbol}_${year}_${quarter.toUpperCase()}.json`;
  const callPath = callLink(exchange, symbol, year, quarter);

  return (
    <>
      <div className="call-text-container">
        <div className="company-details-container">
          <div className="call-info-block">
            <CompanyLogoDiv
              exchange={exchange}
              symbol={symbol}
              divClass="img-container"
            />
            <div className="company-text-details">
              <h1 className="c-title">
                <Link to={companyLink(exchange, symbol)}>{companyName}</Link>
              </h1>
              <div className="text-detail-container">
                <span className="text-quarter">{quarter.toUpperCase()}</span>
                <span className="text-quarter">{year}</span>
              </div>
            </div>
          </div>
          <div className="call-date-container">
            <div className="share-block">
              <button className="btn btn-share">
                <span className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="13"
                    viewBox="0 0 10 13"
                    fill="none"
                  >
                    <path
                      d="M1.8748 4.19376H3.10464C3.35337 4.19376 3.55523 4.39532 3.55523 4.64435C3.55523 4.89338 3.35337 5.09495 3.10464 5.09495H1.8745C1.62607 5.09495 1.4239 5.29712 1.4239 5.54555V11.4382C1.4239 11.6866 1.62607 11.8888 1.8745 11.8888H8.6482C8.89663 11.8888 9.0988 11.6866 9.0988 11.4382V5.54555C9.0988 5.29712 8.89663 5.09495 8.6482 5.09495H7.41807C7.16904 5.09495 6.96747 4.89338 6.96747 4.64435C6.96747 4.39532 7.16904 4.19376 7.41807 4.19376H8.6482C9.39349 4.19376 10 4.80026 10 5.54555V11.4382C10 12.1835 9.39349 12.79 8.6482 12.79H1.8745C1.12921 12.79 0.522705 12.1835 0.522705 11.4382V5.54555C0.523005 4.79996 1.12921 4.19376 1.8748 4.19376ZM6.94164 3.28415L5.69708 2.03959V7.97188C5.69708 8.22061 5.49551 8.42248 5.24648 8.42248C4.99745 8.42248 4.79588 8.22061 4.79588 7.97188V2.03959L3.55133 3.28415C3.46331 3.37216 3.34796 3.41602 3.23261 3.41602C3.11725 3.41602 3.0019 3.37216 2.91388 3.28415C2.73785 3.10841 2.73785 2.82273 2.91388 2.647L4.92746 0.633124C5.10379 0.45709 5.38887 0.45709 5.56491 0.633124L7.57878 2.647C7.75482 2.82273 7.75482 3.10841 7.57878 3.28415C7.40275 3.46018 7.11767 3.46018 6.94164 3.28415Z"
                      fill="#3E3E3E"
                    />
                  </svg>
                </span>
                <span className="lbl">Share</span>
              </button>
              <div className="share-options-container">
                <FacebookShareButton
                  url={`https://earningscall.biz${callPath}`}
                >
                  <div className="share-options-block">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C7.17764 0 0 7.17764 0 16C0 24.8217 7.17764 32 16 32C24.8217 32 32 24.8217 32 16C32 7.17764 24.823 0 16 0ZM19.9791 16.5633H17.376V25.8413H13.5187C13.5187 25.8413 13.5187 20.7718 13.5187 16.5633H11.6852V13.2841H13.5187V11.1631C13.5187 9.64408 14.2406 7.27044 17.4114 7.27044L20.2697 7.2814V10.4645C20.2697 10.4645 18.5328 10.4645 18.1951 10.4645C17.8574 10.4645 17.3773 10.6334 17.3773 11.3578V13.2848H20.3161L19.9791 16.5633Z"
                        fill="#4DEC8C"
                      />
                    </svg>
                  </div>
                </FacebookShareButton>
                <LinkedinShareButton
                  url={`https://earningscall.biz${callPath}`}
                >
                  <div className="share-options-block">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C7.16479 0 0 7.16479 0 16C0 24.8352 7.16479 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16479 24.8352 0 16 0ZM11.3506 24.1875H7.45386V12.4641H11.3506V24.1875ZM9.40234 10.8633H9.37695C8.06934 10.8633 7.22363 9.96313 7.22363 8.83813C7.22363 7.68774 8.09521 6.8125 9.42822 6.8125C10.7612 6.8125 11.5815 7.68774 11.6069 8.83813C11.6069 9.96313 10.7612 10.8633 9.40234 10.8633ZM25.4014 24.1875H21.5051V17.9158C21.5051 16.3396 20.9409 15.2646 19.531 15.2646C18.4546 15.2646 17.8135 15.9897 17.5317 16.6897C17.4287 16.9402 17.4036 17.2903 17.4036 17.6406V24.1875H13.5071C13.5071 24.1875 13.5581 13.564 13.5071 12.4641H17.4036V14.124C17.9214 13.3252 18.8479 12.189 20.9153 12.189C23.479 12.189 25.4014 13.8645 25.4014 17.4653V24.1875Z"
                        fill="#4DEC8C"
                      />
                    </svg>
                  </div>
                </LinkedinShareButton>
                <TwitterShareButton url={`https://earningscall.biz${callPath}`}>
                  <div className="share-options-block">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0Z"
                        fill="#4DEC8C"
                      />
                      <path
                        d="M17.7504 14.5522L24.5998 6.59033H22.9767L17.0293 13.5035L12.2792 6.59033H6.80054L13.9836 17.0443L6.80054 25.3936H8.42372L14.7043 18.093L19.7207 25.3936H25.1994L17.75 14.5522H17.7504ZM9.00856 7.81225H11.5017L22.9774 24.2272H20.4843L9.00856 7.81225Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </TwitterShareButton>
              </div>
            </div>
            <p className="text-date">{date}</p>
          </div>
        </div>

        <div className="content-container">
          {speakerGroups ? (
            <>
              {speakerGroups.map(
                (
                  { speaker, startIndex, endIndex, items, words, start_times },
                  i
                ) => {
                  // log.debug("speakerGroup:", i, speaker, startIndex, endIndex, items, words, start_times);
                  return (
                    <SpeakerSection
                      key={i}
                      exchange={exchange}
                      symbol={symbol}
                      event={{ year, quarter }}
                      buildVersion={buildVersion}
                      wordIndex={getSpeakerSectionWordIndex({
                        activeSpeakerGroup: i === currentSpeakerGroupIndex,
                        version,
                        startIndex,
                        endIndex,
                        currentWordIndex,
                      })}
                      speaker={getSpeakerObject(speaker)}
                      items={items}
                      words={words}
                      start_times={start_times}
                      seekTo={seekTo}
                      version={version}
                    />
                  );
                }
              )}
            </>
          ) : (
            <p>We are missing the transcript for this call. Sorry!</p>
          )}
        </div>
      </div>
      {isTranscriptPreview && (
        <TranscriptPreviewExplanation {...transcriptPreviewExplanationProps} />
      )}
      <div className="about-call">
        <div className="title">Disclaimer</div>
        <div className="content">
          <p className="text">
            This conference call transcript was computer generated and almost
            certianly contains errors. This transcript is provided for
            information purposes only.
            <strong>EarningsCall, LLC</strong> makes no representation about the
            accuracy of the aforementioned transcript, and you are cautioned not
            to place undue reliance on the information provided by the
            transcript.
          </p>
        </div>
      </div>
    </>
  );
};

const NoConferenceCall = (props) => {
  const {
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
  } = props;

  return (
    <div className="no-call-container">
      <div className="c-detail-container">
        <div className="quarter-lbl">{quarter}</div>
        <div className="c-name-lbl">{companyName}</div>
        <div className="year-lbl">{year}</div>
      </div>
      <h1 className="no-call-title">No Conference Call</h1>
      <div className="text-desc">
        It looks like there are no conference call
      </div>
      <div className="btn-container">
        <Link to={`/calendar`} className="btn">
          Go to Calender
        </Link>
      </div>
      <div className="call-img-container">
        <img src={NoCallBg} alt="picture" />
      </div>
    </div>
  );
};

const MissingAudio = (props) => {
  const {
    isApproved,
    optOut,
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
  } = props;
  log.debug(year, quarter.toUpperCase());
  log.debug("conference_date:", conference_date);
  log.debug("props:", props);
  const conferenceDate = new Date(conference_date);
  const today = new Date();
  const { date, day, time } = dayAndTime(conferenceDate);
  log.debug("Day time:", date, day, time);
  const enableCustomLoginForm = isFeatureEnabled(LOGIN_WITH_EMAIL);

  const [renderNewScheduleSection, setRenderNewScheduleSection] =
    useState(false);

  useEffect(() => {
    if (isFeatureEnabled(RENDER_NEW_SCHEDULED_SECTION)) {
      setRenderNewScheduleSection(true);
    }
  }, []);

  return (
    <>
      {renderNewScheduleSection ? (
        <section className="schedule-section">
          <div className="container">
            <div className="schedule-container">
              <div className="schedule-info-block">
                <ScheduleInfo {...props} />
              </div>
              <div className="details-block">
                <CompanyDetails {...props} />
              </div>
            </div>
            <div className="more-block">
              <MoreCalls {...props} />
            </div>
          </div>
        </section>
      ) : (
        <section className="schedule-call-section">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="content">
                  <div className="qno">{quarter.toUpperCase()}</div>

                  <div className="cm-name">
                    <div className="img-container invisible">
                      <img src={abmIndustryImage} alt={`${companyName} Logo`} />
                    </div>
                    <Link to={companyLink(exchange, symbol)}>
                      <h3 className="name">{companyName}</h3>
                    </Link>
                  </div>
                  {isAfter(conferenceDate, today) ? (
                    <>
                      <div className="text">
                        This earning call is scheduled to happen on
                      </div>

                      <div className="schedule">
                        <span className="info">
                          {date} at {time}
                        </span>
                      </div>

                      <div className="lnk-container">
                        <div className="btn without-focus">
                          Please check back later
                          <span className="icon">
                            <img src={rightArrowImage} alt="icon" />
                          </span>
                          {enableCustomLoginForm && (
                            <SignUpForAlerts {...props} />
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="text">
                        This earning call took place on
                      </div>

                      <div className="schedule">
                        <span className="info">
                          {date} at {time}
                        </span>
                      </div>

                      <div className="lnk-container">
                        <div className="btn without-focus">
                          {optOut ? (
                            <>This company has opted-out of earnings calls.</>
                          ) : (
                            <>
                              {isApproved
                                ? "But it looks like we're missing the audio. Please check back later."
                                : "But we're waiting for approval before publishing this call.  Please check back later."}
                            </>
                          )}
                          <span className="icon">
                            <img src={rightArrowImage} alt="icon" />
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="img-container">
                  <img src={telephone2Image} alt="Call Is Scheduled" />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

const transformSpeakerNameMap = (speaker_names) => {
  if (!speaker_names) {
    return undefined;
  }
  const result = {};
  speaker_names?.forEach(({ from, to }) => (result[from] = to));
  return result;
};

const EarningsEvent = (props) => {
  log.debug("EarningsEvent::Render()", props);
  const {
    event: { audio_file, has_conference_call },
    transcript,
    isApproved,
    optOut,
  } = props;
  const {
    items,
    speaker_labels,
    version,
    speaker_groups,
    speaker_names,
    speaker_names_v2,
  } = transcript || {};
  const speakerNames = transformSpeakerNameMap(speaker_names);
  const speakerNamesV2 = transformSpeakerNameMap(speaker_names_v2);
  log.debug(
    "EarningsEvent::Render() speaker_names speakerNamesV2",
    speaker_names,
    speakerNames,
    speakerNamesV2
  );
  const { segments } = speaker_labels || {};
  const speakerGroups = groupItemsBySpeaker({
    items,
    segments,
    version,
    speaker_groups,
  });

  if (!has_conference_call) {
    return (
      <>
        <section className="call-section">
          <div className="container">
            <div className="row">
              <NoConferenceCall {...props} />
            </div>
          </div>
        </section>
      </>
    );
  }

  if (optOut || !audio_file || !isApproved) {
    return <MissingAudio {...props} />;
  }

  const playerProps = { ...props, speakerGroups, speakerNames, speakerNamesV2 };
  return (
    <>
      <section className="call-section">
        <div className="container">
          <div className="row">
            <Player {...playerProps} />
          </div>
        </div>
      </section>
    </>
  );
};

const Call = (props) => {
  log.debug("Call::props", props);
  const { pageContext } = props;
  const {
    exchange,
    symbol,
    companyName,
    event: { year, quarter },
  } = pageContext;
  // const { siteMetadata: { buildVersion } } = site;

  useEffect(() => {
    recordEvent({
      name: "Call",
      exchange,
      symbol,
      year,
      quarter,
    });
  }, [exchange, symbol, year, quarter]);

  useEffect(() => {
    const onScroll = (args) => {
      // log.debug(`${window.innerHeight} + ${window.pageYOffset} = ${window.innerHeight + window.pageYOffset} <> ${document.body.offsetHeight} <> ${document.body.scrollHeight}`);
    };
    const onWindowEvent = (args) => {
      log.debug(`windowEvent: ${args}`);
      const windowWidth = window.innerWidth;
      log.debug("windowWidth:", windowWidth);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onWindowEvent);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onWindowEvent);
    };
  }, []);

  return (
    <>
      <SiteHead
        title={`EarningsCall · ${symbol.toUpperCase()} ${quarter.toUpperCase()} ${year}`}
        description={`${companyName} — ${symbol.toUpperCase()} ${quarter.toUpperCase()} ${year} Earnings Conference Call`}
        pageProps={props}
      />
      <EarningsEvent {...pageContext} />
    </>
  );
};

export { Call };
